export default {"src":"/_next/static/media/piggy-bank-mod.1beae759.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};